<template>
    <div class="modal-card" v-if="addOns.tickets">
      <header class="modal-card-head">
        <p class="modal-card-title">Create ticket</p>
      </header>
      <section class="modal-card-body">
          <b-field label="Title:">
            <b-input :disabled="role === 'viewer'" type="text" v-model="title" placeholder="Ticket title"></b-input>
          </b-field>
          <b-field v-if="bTitleError" style="color: red">
            Please enter a title.
          </b-field>
          <b-field label="Description:">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description" placeholder="Ticket description"></b-input>
          </b-field>
          <b-field v-if="bDescError" style="color: red">
            Please enter a description.
          </b-field>
          <b-field label="Priority:">
            <b-select v-model="selectedPriority">
            <option
                v-for="priority in priorities"
                :key="priority.value"
                :value="priority.value"
            >
                {{ priority.text }}
            </option>
            </b-select>
        </b-field>
        <b-field label="Email:">
            <b-input :disabled="role === 'viewer'" type="text" v-model="email" placeholder="Email"></b-input>
          </b-field>
          <b-field label="Phone number:">
            <b-input :disabled="role === 'viewer'" type="text" v-model="phoneNumber" placeholder="Phone number"></b-input>
          </b-field>

      </section>
      <footer class="modal-card-foot">
        <b-button :disabled="role === 'viewer'" icon-left="plus" type="is-info" @click="addTicket">Create new ticket</b-button>
        <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      </footer>

    </div>
    </template>

<script>

export default {
  name: 'AddTicket',
  props: ['propParentFn'],
  data: () => {
    return {
      title: '',
      description: '',
      priorities: [
        { value: 'low', text: 'Low' },
        { value: 'mid', text: 'Medium' },
        { value: 'high', text: 'High' }
      ],
      selectedPriority: 'low',
      email: '',
      phoneNumber: '',
      bTitleError: false,
      bDescError: false,
      loadingComponent: null,
      ticketId: ''
    }
  },
  computed: {
    role () {
      return this.$store.state.role
    },
    addOns () {
      return this.$store.state.addOns
    }
  },
  methods: {
    closeWindow () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
      this.loadingComponent.close()
    },
    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: 'Submitting ticket failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    addTicket () {
      if (this.role !== 'viewer') {
        this.bTitleError = false
        this.bDescError = false
        if (this.title === '') {
          this.bTitleError = true
        } if (this.description === '') {
          this.bDescError = true
        } else {
          this.loadingComponent = this.$buefy.loading.open()
          let newTicketRef = this.$store.state.database.ref('/neoslide/tickets/' + this.$store.state.workspaceId).push()
          newTicketRef.set({
            id: newTicketRef['key'],
            title: this.title,
            desc: this.description,
            priority: this.selectedPriority,
            email: this.email,
            phoneNumber: this.phoneNumber,
            status: 'unresolved',
            response: '',
            timestamp: Date.now()
          }).then(() => {
            this.closeWindow()
          }).catch(error => {
            this.globalLogger(error)
            this.closeWindow()
            this.showAlert(true)
          })
        }
      }
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tickets/AddTicket.vue